export var headerContentType = 'componentLinkBig';
